module.exports = {
	"root": "findify-components-search--desktop-facets",
	"header": "findify-components-search--desktop-facets__header",
	"icon": "findify-components-search--desktop-facets__icon",
	"title": "findify-components-search--desktop-facets__title",
	"reset": "findify-components-search--desktop-facets__reset",
	"hide": "findify-components-search--desktop-facets__hide",
	"facet": "findify-components-search--desktop-facets__facet"
};